<template>
    <v-row justify="center">
        <v-dialog
            v-model="showVerificationModal"
            persistent
            max-width="600"
        >
            <v-card >
                
            </v-card>
            <v-card>
                <v-card-title class="headline">
                    Verifica tu cuenta
                </v-card-title>
                <v-card-text>
                    Introduce tu correo 
                    <v-text-field 
                        class=""
                        outlined
                        placeholder="Teléfono/Correo/Usuario"
                        :rules="[rules.email.required, rules.email.valid_email]"
                        v-model="email"
                    >
                    </v-text-field>
                    <div class="d-flex justify-center pb-3">
                         <v-btn
                        :color="pantone"
                        class="white--text"
                        @click="sendEmail()"
                        :disabled="pausedFor5Seconds"
                        >
                            mandar correo
                        </v-btn>
                    </div>

                    Introduce el código de verificación que recibió por email <b>({{account.user.email}}) </b>:
                    <v-text-field
                        class="text-h4 centered-input py-1"
                        align="center"
                        maxlength="6"
                        counter
                        outlined
                        v-model="verificationCode"
                        :error-messages="getErrorMessage()"
                        :success-messages="getSuccessMessage()"
                    >

                    </v-text-field>
                    <!-- <div>
                        * Si no ha recibido el email con el código de verificación; ó su código ha vencido, puede solicitar uno nuevo.
                        <a href="javascript:void(0)" @click="requestResendVerificationCode()"> Solicitar código de verificación. </a>
                    </div>
                    <div class="pt-4">
                        * Si su email es incorrecto o desea recibir el código con otra cuenta de correo, puede cambiarlo en el Perfil de Usuario
                        <router-link :to="{name:'user_profile'}"> Ir a mi perfil. </router-link>
                    </div> -->

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="tryAvailable && $route.name !== 'portfolio'"
                        color="normal"
                        text
                        @click="skipVerificationCode()"
                    >
                        Verificar mas tarde
                    </v-btn>
                    <v-btn
                        :color="pantoneBlack"
                        class="white--text"
                        @click="requestVerifyUserCode()"
                        :disabled="!verificationCode || verificationCode.length < 6"
                    >
                        Verificar mi cuenta
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";
import * as Storage from 'bestgob-core/core/storage.js'
import Constants from "bestgob-core/core/constants";

export default {
    name: "AccountVerification",

    data(){
        return {
            showVerificationModal:  false,
            needVerification: false,
            verificationCode: null,
            email: this.$store.state.account.user.email,
            pausedFor5Seconds: false,
            tryAvailable: true,
            rules: {
                  email: {
                      required: value => !!value || 'El campo Email es requerido.',
                      valid_email: v => /\S+@\S+\.\S+/.test(v) || 'El email no es válido'
                  },
            },
            pantone: '#B08C55',
            pantoneBlack: '#15212F'
        }
    },

    watch: {
        '$store.state.account.userHasTryAvailable'(){
            let skippedDialog = Storage.getItem(Constants.KEY_SKIP_VERIFICATION_CODE)
            this.tryAvailable = this.account.userHasTryAvailable
            if (!this.tryAvailable || !skippedDialog){
                this.needVerification = true
                this.validateShowVerification()
            }
        },

        '$route'(){
            this.validateShowVerification()
        },

        '$store.state.account.isJustProfileUpdated'(){
            this.validateShowVerification()
        }
    },

    computed: {
        ...mapState({account: state => state.account, alert: state => state.alerts}),
    },

    created() {
        //this.getTryAvailable()
    },

    methods: {
        ...mapActions('account', ['resendVerificationCode', 'verifyUserCode', 'getTryAvailable']),

        sendEmail(){
            this.requestResendVerificationCode()
            //todoL mandar el correo
                this.pausedFor5Seconds = true
            setTimeout(() => {
                this.pausedFor5Seconds = false
            }, 5000);
        },

        requestVerifyUserCode(){
            let request = {verify_code: this.verificationCode}

            this.verifyUserCode(request)
        },

        requestResendVerificationCode(){
            let request = {email : this.email}
            this.resendVerificationCode(request)
        },

        skipVerificationCode(){
            Storage.setItem(Constants.KEY_SKIP_VERIFICATION_CODE, '1')
            this.showVerificationModal = false
        },

        getErrorMessage(){
            if (this.alert.type === 'error'){
                return this.alert.message
            }

            return null;
        },

        getSuccessMessage(){
            if (this.alert.type === 'success'){
                return this.alert.message
            }

            return null
        },

        validateShowVerification(){
            let isOnProfilePage  = this.$route.name === 'user_profile'
            let isOnPortfolioPage  = this.$route.name === 'portfolio'

            if (isOnProfilePage){
                this.showVerificationModal = this.account.isJustProfileUpdated
            }
            else if (isOnPortfolioPage && !this.account.user.confirmado == '0'){
                this.showVerificationModal = true
            }
            else{
                this.showVerificationModal = this.needVerification
            }
        }
    },
}
</script>

<style  > 
   
    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: .7rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */
</style>